export async function copyToClipboard(textToCopy: string) {
  try {
    await navigator.clipboard.writeText(textToCopy);
  } catch (error) {
    console.error('Failed to copy: ', error);
  }
}
